import { Link } from "react-router-dom";
import styles from "../styles/Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>
        Designed & created by{" "}
        <a
          href="https://cytechsharp.com.cy"
          target="_blank"
          rel="noopener noreferrer"
        >
          CyTechSharp
        </a>
      </p>

      <div className={styles.footerLinks}>
        <Link to="/privacy-policy">Privacy Policy</Link>

        <span>•</span>

        <Link to="/terms-of-service">Terms of Service</Link>
      </div>
    </footer>
  );
}

export default Footer;